import { useSelector } from 'react-redux'
import rocket from '../../assets/images/rocket.gif'
import styled from 'styled-components'
import { State } from 'src/features/types'

const LoaderWrapper = styled.div`
  display: flex;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 10000;
`

const LoaderImage = styled.div`
  display: flex;
  flex: 0 1 auto;
  img {
    width: 320px;
    height: 320px;
  }
`

const Loader = () => {
  const isLoading = useSelector((state: State) => state.app.isLoading)
  return (
    <LoaderWrapper className={`loader-wrapper ${isLoading ? '' : 'loderhide'}`}>
      <LoaderImage>
        <img src={rocket} alt='Foguete decolando' />
      </LoaderImage>
    </LoaderWrapper>
  )
}

export default Loader
